import PrLogoFooterComponent from './pr-logo-footer';

export default PrLogoFooterComponent;